
import { EMPTY, map, Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { ACCOUNT_STORE } from '../../domain/tokens/account-store.token';
import { EVENT_BUS} from "../../../../../shared/domain/tokens/event-bus.token";
import { EntriesChangedEvent } from "../../../../../shared/application/events/entry/entries-changed.event";

@Injectable({ providedIn: 'root' })
export class RemoveAllEntriesUseCase {
  private readonly accountStore = inject(ACCOUNT_STORE);
  private readonly eventBus = inject(EVENT_BUS);

  /**
   * Removes specific entries by their IDs from the selected account
   * @param entriesId Optional array of entry IDs to remove. If not provided, removes all entries.
   */
  execute(entriesId?: string[]): Observable<void> {
    const account = this.accountStore.getSelectedAccount();

    if (!account) {
      return EMPTY;
    }

    if (entriesId && entriesId.length > 0) {
      entriesId.forEach(id => {
        const entryToRemove = account.entries?.find(entry => entry._id === id);

        if (entryToRemove) {
          account.removeEntry(entryToRemove);
          this.eventBus.publish(new EntriesChangedEvent([entryToRemove], 'removed'));
        }
      });
    } else {
      account.removeAllEntries();
      this.eventBus.publish(new EntriesChangedEvent([], 'removed'));
    }

    return this.accountStore.saveSelectedAccount(account).pipe(
      map(() => void 0)
    );
  }
}
